// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.List-module__root--EvFgj {
  list-style: none;
  padding: 0;
  margin: 0;
}

.List-module__column-1--FBq86,
.List-module__column-2--INPn_,
.List-module__column-3--YBuOR,
.List-module__column-4--VjOIR,
.List-module__column-5--AyO38,
.List-module__column-6--TzCND {
  display: grid;
  column-gap: 28px;
}

.List-module__column-1--FBq86 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.List-module__column-2--INPn_ {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.List-module__column-3--YBuOR {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.List-module__column-4--VjOIR {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.List-module__column-5--AyO38 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.List-module__column-6--TzCND {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.List-module__ui-List-Item--xAUcA {
  list-style: none;
  padding: 21px 8px;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid var(--chaek-color-border-divider);
  gap: 17px;
}

.List-module__ui-List-Item-Leading--d35nF {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1px;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 2px;
}

.List-module__ui-List-Item-Content--GzJ14 {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 5px;
  text-decoration: none;
  color: inherit;
}

.List-module__ui-List-Item-Trailing--dUpun {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  flex-shrink: 0;
  color: var(--chaek-color-text-source-333333);
  font-size: 11px;
  line-height: normal;
  letter-spacing: 0.06px;
}

.List-module__ui-List-Item-Content--GzJ14 .List-module__title--WqJVB {
  color: var(--chaek-color-text-primary);
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  letter-spacing: -0.8125px;
}

.List-module__ui-List-Item-Content--GzJ14 .List-module__content--SnNnp {
  color: var(--chaek-color-text-muted);
  font-size: 11px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.0645px;
}

.List-module__ui-List-Item-Content--GzJ14 .List-module__description--WTZaH {
  padding-top: 4px;
  font-size: 0.75rem; /* 12px */
  color: #888888;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/List/List.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;;;;;;EAME,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0DAA0D;EAC1D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,4CAA4C;EAC5C,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB,EAAE,SAAS;EAC7B,cAAc;AAChB","sourcesContent":[".root {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.column-1,\n.column-2,\n.column-3,\n.column-4,\n.column-5,\n.column-6 {\n  display: grid;\n  column-gap: 28px;\n}\n\n.column-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n.column-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.column-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.column-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.column-5 {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.column-6 {\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n}\n\n.ui-List-Item {\n  list-style: none;\n  padding: 21px 8px;\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-bottom: 1px solid var(--chaek-color-border-divider);\n  gap: 17px;\n}\n\n.ui-List-Item-Leading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 1px;\n  overflow: hidden;\n  flex-shrink: 0;\n  border-radius: 2px;\n}\n\n.ui-List-Item-Content {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  flex-direction: column;\n  gap: 5px;\n  text-decoration: none;\n  color: inherit;\n}\n\n.ui-List-Item-Trailing {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 44px;\n  flex-shrink: 0;\n  color: var(--chaek-color-text-source-333333);\n  font-size: 11px;\n  line-height: normal;\n  letter-spacing: 0.06px;\n}\n\n.ui-List-Item-Content .title {\n  color: var(--chaek-color-text-primary);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 22.4px;\n  letter-spacing: -0.8125px;\n}\n\n.ui-List-Item-Content .content {\n  color: var(--chaek-color-text-muted);\n  font-size: 11px;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.0645px;\n}\n\n.ui-List-Item-Content .description {\n  padding-top: 4px;\n  font-size: 0.75rem; /* 12px */\n  color: #888888;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `List-module__root--EvFgj`,
	"column-1": `List-module__column-1--FBq86`,
	"column-2": `List-module__column-2--INPn_`,
	"column-3": `List-module__column-3--YBuOR`,
	"column-4": `List-module__column-4--VjOIR`,
	"column-5": `List-module__column-5--AyO38`,
	"column-6": `List-module__column-6--TzCND`,
	"ui-List-Item": `List-module__ui-List-Item--xAUcA`,
	"ui-List-Item-Leading": `List-module__ui-List-Item-Leading--d35nF`,
	"ui-List-Item-Content": `List-module__ui-List-Item-Content--GzJ14`,
	"ui-List-Item-Trailing": `List-module__ui-List-Item-Trailing--dUpun`,
	"title": `List-module__title--WqJVB`,
	"content": `List-module__content--SnNnp`,
	"description": `List-module__description--WTZaH`
};
export default ___CSS_LOADER_EXPORT___;
